import React from 'react'
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import CommentLogsCard from './CommentCard';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})

class CommentLogs extends React.Component {
    render() {
        let comments;
        if (this.props.comments && this.props.comments.length > 0) {
            comments = this.props.comments && this.props.comments.map((item, i) => {
                return <CommentLogsCard key={i} item={item} index={i} />
            })
        } else {
            comments = "No On Hold Comments Found"
        }
        return (
            <div>
                {comments}
            </div>
        )
    }
}

export default CommentLogs